module.exports = __webpack_public_path__ + "static/img/hatchback-yellow.24aa31c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/hatchback-yellow.svg
// module id = 8Er1
// module chunks = 74